/* eslint-disable no-underscore-dangle */
import React from 'react';
import Feed from './Feed';

export const App = () => {
  return (
    <div className="feed-wrapper">
      <Feed />
    </div>
  );
}